module.exports = __webpack_public_path__ + "img/图像识别算法.2eaabaeb.png";